export const paginate = (
  currentPage: number,
  totalPages: number,
  screenType = 'large'
) =>
  screenType === 'large'
    ? paginateLarge(currentPage, totalPages)
    : paginateSmall(currentPage, totalPages);

const paginateLarge = (currentPage: number, total: number) => {
  if (total <= 6) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  return currentPage <= 3 || currentPage >= total - 2
    ? [1, 2, 3, -1, total - 2, total - 1, total]
    : [1, -1, currentPage - 1, currentPage, currentPage + 1, -1, total];
};

const paginateSmall = (currentPage: number, total: number) => {
  if (total <= 5) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  return currentPage <= 2 || currentPage >= total - 1
    ? [1, 2, -1, total - 1, total]
    : [1, -1, currentPage, -1, total];
};

export const calcTotalPages = (totalItems: number, pageSize: number) =>
  Math.ceil(totalItems / pageSize);

export const calcPreviousPage = (pageIndex: number) =>
  pageIndex > 1 ? pageIndex - 1 : 1;

export const calcNextPage = (pageIndex: number, totalPages: number) =>
  pageIndex < totalPages ? pageIndex + 1 : totalPages;

export const calcStartIndex = (currentPage: number, pageSize: number) =>
  (currentPage - 1) * pageSize + 1;

export const calcEndIndex = (
  currentPage: number,
  pageSize: number,
  totalItems: number
) => Math.min(currentPage * pageSize, totalItems);
